<script>
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		components: {
			'featured-content': require('components/product-promotion/featured-content.vue').default
		},
		props: {
			node: {
				default: null
			},
			products: {
				default: []
			},
			onProductClick: {
				type: Function
			},
			href: {
				default: null
			},
			hires: {
				default: false
			},
			debug: {
				default: false
			}
		},
		computed: {
			imageUrl() {
				let node = this.node;
				let url = '';
				if (node) {
					if (this.hires) {
						url = node.imgUrl;
					} else {
						url = node.thumbnailUrl;
					}
				}
				return assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.spotlight-promo {
		margin-bottom: 2rem;

		.spotlight-header {
			display: flex;
			margin-bottom: 2rem;
			flex-wrap: wrap;

			h2 {
				margin-top: 0;
				margin-bottom: 0.25rem;
			}

			h3 {
				font-size: 1.25rem;
				font-weight: normal;
				margin-top: 0;
			}

			.spotlight-image-container {
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			.spotlight-blurb {
				flex: 1;
				padding-left: 1rem;
				flex-basis: 400px;

				p {
					font-weight: 500;
				}
			}
		}

		.spotlight-products {
			.featured-content {
				border-bottom-width: 0px;
				padding-bottom: 1rem;
				margin-bottom: 0rem;
			}
		}

		.spotlight-link {
			display: flex;
			justify-content: center;
			border-bottom: 1px solid $c-grey;
			padding-bottom: 2rem;
			margin-bottom: 2rem;
		}
	}
</style>
<template>
	<div
		v-if="node"
		class="spotlight-promo">
		<div class="spotlight-header">
			<div class="spotlight-image-container">
				<img
					v-if="!href"
					class="spotlight-image"
					:src="imageUrl" />
				<a
					v-if="href"
					:href="href">
					<img
						class="spotlight-image"
						:src="imageUrl" />
				</a>
			</div>
			<div class="spotlight-blurb">
				<h2 v-if="node.name">{{ node.name }}</h2>
				<h3 v-if="node.subtitle">{{ node.subtitle }}</h3>
				<div
					v-if="node.description"
					v-html="node.description"></div>
			</div>
		</div>
		<div
			class="spotlight-products"
			v-if="products && products.length">
			<featured-content
				:content="products"
				:on-product-link-click="onProductClick"
				:debug="debug">
			</featured-content>
		</div>
		<div
			v-if="href"
			class="spotlight-link">
			<a
				:href="href"
				class="button">
				Browse Reading List
			</a>
		</div>
	</div>
</template>
